export default class WorkPlanPhaseExecutionCtrl{

  constructor($scope, $rootScope, WorkPlanSrv, $mdDialog, $cookieStore, $sessionStorage){
    var workPlanPhaseExecutionVm = this
    $rootScope.fullscreenClass = 'background-planning'
    workPlanPhaseExecutionVm.showModalMessages = showModalMessages
    workPlanPhaseExecutionVm.messagesList = []
    workPlanPhaseExecutionVm.userId = 0
    workPlanPhaseExecutionVm.teacherId = 0
    workPlanPhaseExecutionVm.radioGreen = "#04B404"
    workPlanPhaseExecutionVm.workPlanGeneralList = $sessionStorage.workPlanGeneralList
    workPlanPhaseExecutionVm.$sessionStorage = $sessionStorage


    workPlanPhaseExecutionVm.assignStyles = () => {
      switch(workPlanPhaseExecutionVm.timeline) {
        case "Planeación":
          workPlanPhaseExecutionVm.classRadioGreenPlaneation = {backgroundColor: workPlanPhaseExecutionVm.radioGreen}
          workPlanPhaseExecutionVm.classBarGreen = {width: "60px"}
          break
        case "Aprobación":
          workPlanPhaseExecutionVm.classRadioGreenPlaneation = {backgroundColor: workPlanPhaseExecutionVm.radioGreen}
          workPlanPhaseExecutionVm.classRadioGreenApproval = {backgroundColor: workPlanPhaseExecutionVm.radioGreen}
          workPlanPhaseExecutionVm.classBarGreen = {width: "150px"}
          break
        case "Ejecución":
          workPlanPhaseExecutionVm.classRadioGreenPlaneation = {backgroundColor: workPlanPhaseExecutionVm.radioGreen}
          workPlanPhaseExecutionVm.classRadioGreenApproval = {backgroundColor: workPlanPhaseExecutionVm.radioGreen}
          workPlanPhaseExecutionVm.classRadioGreenExecution = {backgroundColor: workPlanPhaseExecutionVm.radioGreen}
          workPlanPhaseExecutionVm.classBarGreen = {width: "240px"}
          break
        case "Evaluación":
          workPlanPhaseExecutionVm.classRadioGreenPlaneation = {backgroundColor: workPlanPhaseExecutionVm.radioGreen}
          workPlanPhaseExecutionVm.classRadioGreenApproval = {backgroundColor: workPlanPhaseExecutionVm.radioGreen}
          workPlanPhaseExecutionVm.classRadioGreenExecution = {backgroundColor: workPlanPhaseExecutionVm.radioGreen}
          workPlanPhaseExecutionVm.classRadioGreenEvaluation = {backgroundColor: workPlanPhaseExecutionVm.radioGreen}
          workPlanPhaseExecutionVm.classBarGreen = {width:"350px"}
          break
        default:
      }
    }

    activate()

    function activate() {
      workPlanPhaseExecutionVm.userId = $cookieStore.get("currentUser").id
      workPlanPhaseExecutionVm.teacherId = $cookieStore.get("currentUser").teacherId
      getElements()
      getMessages()

    }

    function getElements(){
      if(workPlanPhaseExecutionVm.workPlanGeneralList == undefined){
      	// Right Bar
        WorkPlanSrv.getElementsRightBar.getList({teacherId:workPlanPhaseExecutionVm.teacherId}).$promise.then(function(dataReturn) {
          if(dataReturn.status == true){
            var index = 0
            workPlanPhaseExecutionVm.$sessionStorage.workPlanGeneralList = dataReturn.data
            workPlanPhaseExecutionVm.RightBar = dataReturn.data
            console.log(workPlanPhaseExecutionVm.RightBar)
            workPlanPhaseExecutionVm.percentage = workPlanPhaseExecutionVm.RightBar.asignaturesPlaned[index].percentage
            workPlanPhaseExecutionVm.timeline = workPlanPhaseExecutionVm.RightBar.timeline[index].stage
            workPlanPhaseExecutionVm.assignStyles()
          }else{
            console.log("Comunications problem with the server")
          }
        },function(data) {
             console.log(data)
        })
      }else{
        var index = 0
        workPlanPhaseExecutionVm.RightBar = workPlanPhaseExecutionVm.workPlanGeneralList
        console.log(workPlanPhaseExecutionVm.RightBar)
        workPlanPhaseExecutionVm.percentage = workPlanPhaseExecutionVm.RightBar.asignaturesPlaned[index].percentage
        workPlanPhaseExecutionVm.timeline = workPlanPhaseExecutionVm.RightBar.timeline[index].stage
        workPlanPhaseExecutionVm.assignStyles()
      }
    }

    function getMessages () {
      WorkPlanSrv.getMessages.get({userId:workPlanPhaseExecutionVm.userId}).$promise.then(function (dataReturn) {
        if (dataReturn.status === true) {
          workPlanPhaseExecutionVm.messagesList = dataReturn.data
        } else {
          workPlanPhaseExecutionVm.messagesList = []
        }
      }, function (data) {
        console.log(data)
      })
    }

    function showModalMessages(){
    	let userId       = workPlanPhaseExecutionVm.userId
    	let messagesList = workPlanPhaseExecutionVm.messagesList
      $mdDialog.show({
        controller: ['$scope', '$mdDialog', function showModalMessages($scope, $mdDialog) {
        	var modalMessagesVm = this

        	//declaracion de variables
          modalMessagesVm.userId       = userId
          modalMessagesVm.messagesList = messagesList
			    modalMessagesVm.class1       = "mdi-hardware-keyboard-arrow-down"
			    modalMessagesVm.class2       = "mdi-hardware-keyboard-arrow-up"
			    modalMessagesVm.classRead    = "mdi-content-drafts"
			    modalMessagesVm.classUnRead  = "mdi-content-mail"

			    //declaracion de funciones
			    modalMessagesVm.showMessage = showMessage
			    modalMessagesVm.close       = close

			    activate()
			    function activate(){
			    	//updateReadMessage()
			    }

			    function showMessage(pos) {
			      if (modalMessagesVm.messagesList[pos].isHiden) {
			        modalMessagesVm.messagesList[pos].isHiden = false
			      } else {
			        modalMessagesVm.messagesList[pos].isHiden = true
			      }
			      //si el mensaje esta leido se muestra un ojo justo al lado de la flecha que muestra el mensaje.
			     	//en caso contrario no muestra nada
			      if (modalMessagesVm.messagesList[pos].isRead == 0) {
			      	updateReadMessage()
			      }
			    }

			    function updateReadMessage () {
			      WorkPlanSrv.updateReadingMessages.update({
			      	userId:modalMessagesVm.userId
			      }).$promise.then(function (dataReturn) {
			      	console.log(dataReturn)
			        if (dataReturn.status) {
			        	for (var i = modalMessagesVm.messagesList.length - 1; i >= 0; i--) {
			        		modalMessagesVm.messagesList[i].isRead = 1
			        	}

			        } else {
			          console.log('error de comunicacion con el servidor')
			        }
			      }, function (data) {
			        console.log(data)
			      })
			    }

          function close() {
          	$mdDialog.hide();
          }

        }],
        template: require('./messagesModalWorkPlanPhaseExecution.html'),
        controllerAs: 'modalMessagesWorkPlanPhaseExecutionVm',
        clickOutsideToClose:false
      });
    }

  }
}

WorkPlanPhaseExecutionCtrl.$inject = ['$scope','$rootScope','WorkPlanSrv','$mdDialog', '$cookieStore', '$sessionStorage'];



// WEBPACK FOOTER //
// ./src/app/u-faculty/workplan/start/execution/workplanPhaseExecutionCtrl.js